import React from "react";

import { useHash } from "./use_hash";

import * as dateish from "js/dateish";

import FileImport from "./file_import";
import BirdPage from "./pages/bird_page";
import HomePage from "./pages/home_page";
import { useDatabase } from "web/hooks";
import DateishPage from "./pages/dateish_page";
import CalendarPage from "web/ui/pages/calendar_page";
import MapPage from "web/ui/pages/map_page";
import BirdsPage from "web/ui/pages/birds_page";

const Router = () => {
  const db = useDatabase();

  const hash = useHash();

  // Treat the hash as a url so we can still use query params. Using `file:` is
  // an easy way to not care about the base
  const { searchParams, pathname } = new URL(hash.slice(1), 'file:');
  const id = searchParams.get('id');

  switch (pathname) {
    case "":
    case "/":
      return <HomePage />;
    case "/bird":
    case "/bird/":
      return <BirdPage spcode={ id! } />;
    case "/birds":
    case "/birds/":
      return <BirdsPage />;
    case "/cal":
    case "/cal/":
      return <CalendarPage />;
    // TODO: combine with above
    case "/date":
    case "/date/": {
      const doy = searchParams.get('doy');
      if (doy != null) { // TODO and is valid DoY
        return <DateishPage date={ { kind: 'doy', value: doy as dateish.DoY } } />;
      }
      const moy = searchParams.get('moy');
      if (moy != null) {
        return <DateishPage date={ { kind: 'moy', value: moy as dateish.MoY } } />;
      }
    } break;
    case "/import":
    case "/import/":
      return <FileImport />;
    case "/map":
    case "/map/":
      return <MapPage />;
    case "/reset":
    case "/reset/": // TODO: Expose this in the UI
      db.reset().finally(() => {
        window.location.href = '/#/import';
      });
      return null;
  }

  return <div>404</div>;
};

export default Router;
